export function formatAssetDisplayName(assetName: string): string {
  const filename = assetName.split("/").pop() ?? assetName;

  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) {
    return filename;
  }

  return filename.slice(0, Math.max(0, lastDotIndex));
}
